<template>
  <svg :width="width" :height="height" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 10.5C24 9 19.8462 7.73077 14.4231 7.38462V4.96154H21.2308V0H2.53846V4.96154H9.34615V7.38462C4.03846 7.73077 0 9 0 10.5C0 12 4.03846 13.2692 9.34615 13.5V22.1538H14.3077V13.5C19.8462 13.2692 24 12 24 10.5ZM12 12C6.11538 12 1.38462 11.0769 1.38462 9.92308C1.38462 9 4.84615 8.19231 9.46154 7.96154V8.53846V10.8462C10.2692 10.8462 11.1923 10.9615 12.1154 10.9615C12.9231 10.9615 13.7308 10.9615 14.5385 10.8462V7.96154C19.2692 8.19231 22.7308 9 22.7308 9.92308C22.6154 11.0769 17.8846 12 12 12Z" :fill="fill"/>
  </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#FFFFFF'
    },
    width: {
      type: Number,
      default: 25
    },
    height: {
      type: Number,
      default: 25
    }
  }
}
</script>
